export const PRODUCTION_OWNERS = [
  { id: 6, name: "Alex" },
  { id: 194, name: "Jade" },
];

export const MARKETS = ["Generic", "EU", "US", "ECOM", "China", "Customized"];

export const PACKAGING_TYPES = [
  "Inner Box",
  "Shrink Wrap",
  "Carded Box",
  "Clam Shell",
  "Paper Card",
  "Craft Box",
  "Hang Tag",
];
